<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead :title="'Ayax Scrap'+(mails?'('+mails.length+'/'+result.reduce((a,b)=>a+(b.Reservations?b.Reservations.length:0),0)+')':'')"></cardHead>
      <ul class="row" v-if="mails">
        <li class="col-auto">
          <b>Toplam Mail:</b>{{ mails.length }}<br>
        </li>
        <li class="col-auto">
          <b>Toplam Satır:</b>{{ result.length }}<br>
        </li>
        <li class="col-auto">
          <b>Toplam Rezervasyon:</b>{{ result.reduce((a,b)=>a+(b.Reservations?b.Reservations.length:0),0) }}<br>
        </li>
        <li class="col-auto">
          <b>Toplam Çevrilen:</b>{{ result.filter(x=>x.IsSuccess).length }}<br>
        </li>
        <li class="col-auto">
          <b>Toplam Çevrilemeyen:</b>{{ result.filter(x=>!x.IsSuccess).length }}<br>
        </li>
        <li class="col-auto">
          <b>Docx Sayısı:</b>{{ result.filter(x=>x.IsSuccess && x.File.indexOf('.docx')>-1).length }}<br>
        </li>
        <li class="col-auto">
          <b>RTF Sayısı:</b>{{ result.filter(x=>x.IsSuccess && x.File.indexOf('.rtf')>-1).length }}<br>
        </li>
        <li class="col-auto">
          <b>PDF Sayısı:</b>{{ result.filter(x=>x.IsSuccess && x.File.indexOf('.pdf')>-1).length }}<br>
        </li>
      </ul>
      <loadArea v-if="loading"></loadArea>
    <div class="myTable p-10">
        <div class="table-responsive">
            <table id="table table-striped" class="table table-bordered table-condensed table-hover table-striped">
          <thead>
            <tr>
              <th rowspan="2">IsSuccess</th>
              <th colspan="12">Reservations</th>
              <th rowspan="2">Errors</th>
            </tr>
            <tr>
              <th>C.Type</th>
              <th>Hotel</th>
              <th>Room</th>
              <th>Voucher</th>
              <th>Checkin</th>
              <th>Checkout</th>
              <th>SaleDate</th>
              <th>Board</th>
              <td>Market</td>
              <th>Guest</th>
              <th>Notes</th>
              <td>A+C+I</td>
            </tr>
            </thead>
            <tbody>
              <template v-for="(item, ii) in result">
                <!-- rezervasyonlu döküman: her rezervasyon için bir satır -->
                <template v-if="item.Reservations && item.Reservations.length">
                  <tr class="nowrap" v-for="(res, ri) in item.Reservations" :key="ii + '-' + ri">
                    <td v-if="ri === 0" :rowspan="item.Reservations.length">
                      <a :href="'https://reservations.ams3.digitaloceanspaces.com/attachments/' +
                      item.File" target="_blank" :title="item.File">{{ item.File.split('.').reverse()[0] }}</a>
                      {{ item.IsSuccess }}
                    </td>
                    <td>{{ res.ConfirmationType.Name }}</td>
                    <td>{{ res.ProviderHotelName }}</td>
                    <td><b>{{ res.Room.Count }}x</b>{{ res.Room.Name }}</td>
                    <td>{{ res.Voucher.Client }}</td>
                    <td>{{ $moment(res.Checkin).format('DD.MM.YYYY') }}</td>
                    <td>{{ $moment(res.Checkout).format('DD.MM.YYYY') }}</td>
                    <td>{{ $moment(res.Sale.Date).format('DD.MM.YYYY HH:mm') }}</td>
                    <td>{{ res.Pension }}</td>
                    <td>{{ res.ProviderMarket }}</td>
                    <td>
                      <ol class="m-0 p-0" style="padding-left: 10px !important;">
                        <li v-for="(guest, gi) in res.Persons" :key="gi">{{guest.Gender.Name}} <b style="font-weight:500">{{ guest.FullName }}</b> <template v-if="guest.BirthDate">{{ $moment(guest.BirthDate).format('DD.MM.YYYY') }}({{ guest.Age }})</template></li>
                      </ol>
                    </td>
                    <td>
                      <ol class="m-0 p-0" style="padding-left: 10px !important;">
                        <li v-for="(note, ni) in res.Notes" :key="ni"><b style="font-weight:500">{{ note.Type }}:</b> {{ note.Content }}</li>
                      </ol></td>
                    <td>{{ res.Pax.Adult + '+' + res.Pax.Child + '+' + res.Pax.Infant }}</td>
                    <td v-if="ri === 0" :rowspan="item.Reservations.length">{{ item.Errors }}</td>
                  </tr>
                </template>
                <!-- rezervasyon yok / hata -->
                <tr class="nowrap" v-else :key="ii">
                  <td>
                    <a :href="'https://reservations.ams3.digitaloceanspaces.com/attachments/' +
                    item.File" target="_blank" :title="item.File" class="fas fa-file-pdf"></a>
                    {{ item.IsSuccess }}
                  </td>
                  <td colspan="11"></td>
                  <td>{{ item.Errors }}</td>
                </tr>
              </template>
            </tbody>
        </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JSZip from 'jszip';
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
// worker.entry import'u window.pdfjsWorker'ı ayarlar -> ana-thread "fake worker"
// (webpack 4 / vue-cli ile worker-loader gerektirmez)
import 'pdfjs-dist/legacy/build/pdf.worker.entry';

// Dokümandaki etiket -> camelCase key eşlemesi
const LABEL_MAP = {
  'Firm': 'firm',
  'Phone': 'phone',
  'Address': 'address',
  'Hotel': 'hotel',
  'Room': 'room',
  'Accom.type': 'accomType',
  'Res.No': 'resNo',
  'Reservation date': 'reservationDate',
  'Check-in date': 'checkInDate',
  'Meal': 'meal',
  'Check-out date': 'checkOutDate',
  'Nights': 'nights',
  'Arrival time': 'arrivalTime',
  'Market': 'market',
  'Net price': 'netPrice',
  'Note': 'note',
  'Pax': 'pax',
  'Manager': 'manager',
  'Touroperator': 'touroperator',
};

export default {
  name: 'home',
  data() {
    return {
      loading: false,
      mails:null,
      result: [],
    };
  },
  created(){
    this.get();
  },
  methods: {
    get() {
      this.$appAxiosAdmin
        .post(`KOLAYREZ/Mails`, {
            "BeginReceiveDate": null,
            "EndReceiveDate": null,
            "BeginMailDate": null,
            "EndMailDate": null,
            "ProviderId": null,
            "CustomerId": null,
            "IsRead": null,
            "IsConverted": null,
            "MailId": null,
            "FromAddress": "reservation1@ayaxglobal.com",
            "ToAddress": null,
            "Subject": null,
            "IsFromAddressRequired": false,
            "IsToAddressRequired": false
        })
        .then(async (response) => {
          const filtered = (response.data || [])
          .filter(
            (m) => /^\d/.test((m.Subject || '').trim())
          );
          // rastgele 5 item seç
          this.mails = filtered
            // .slice()
            // .sort(() => Math.random() - 0.5)
            // .slice(0, 1);
          this.loading = true;
          try {
            for (const element of this.mails) {
              const mail = await this.$appAxiosAdmin
                .get(`KOLAYREZ/Mails/` + element.Id);
              for (const docx of (mail.data.Attachments || [])) {
                await this.loadVoucher(docx);
              }
            }
          } finally {
            console.log("this.result",this.result);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$swal({
            icon: "error",
            title: "Error",
            text: err,
          });
        });
    },


    async loadVoucher(d) {
      try {
        // 1) dosyayı çek
        const url = 'https://reservations.ams3.digitaloceanspaces.com/attachments/' +
                  d.BucketFileName;
        const res = await fetch(url);
        if (!res.ok) throw new Error('Dosya çekilemedi: ' + res.status);

        // 2) formata göre satırlara çevir (.docx -> XML, .rtf -> RTF, .pdf -> pdf.js)
        const ext = (d.BucketFileName || '').split('.').pop().toLowerCase();
        let lines;
        if (ext === 'rtf') {
          const rtf = await res.text();
          lines = this.extractLinesFromRtf(rtf);
        } else if (ext === 'pdf') {
          const buffer = await res.arrayBuffer();
          lines = await this.extractLinesFromPdf(buffer);
        } else {
          const buffer = await res.arrayBuffer();
          const zip = await JSZip.loadAsync(buffer);
          const xmlStr = await zip.file('word/document.xml').async('string');
          lines = this.extractLines(xmlStr);
        }

        // 3) dökümandaki her rezervasyon için düz (flat) ara veri
        const flats = this.parseVouchers(lines);

        // 5) her birini rezervasyon modeline uyarla
        const reservations = flats.map((f) => this.mapToReservation(f));
        this.result.push({
          "IsSuccess": true,
          "Count": reservations.length,
          Reservations: reservations,
          File: d.BucketFileName,
        });
      } catch (e) {
        this.result.push({
          "IsSuccess": false,
          "Count": 0,
          Reservations:null,
          Errors: e.message || String(e),
          File: d.BucketFileName,
        });
      }
    },

    // <w:p> paragraflarındaki metni sırayla, boşları atlayarak diziye al
    extractLines(xmlStr) {
      const doc = new DOMParser().parseFromString(xmlStr, 'application/xml');
      const paras = doc.getElementsByTagName('w:p');
      const lines = [];
      for (let i = 0; i < paras.length; i++) {
        const ts = paras[i].getElementsByTagName('w:t');
        let s = '';
        for (let j = 0; j < ts.length; j++) s += ts[j].textContent;
        s = s.trim();
        if (s) lines.push(s);
      }
      return lines;
    },

    // RTF metnini, docx ile aynı mantıkta satır dizisine çevirir.
    // \par \line \cell \row gibi kontrol kelimeleri satır/hücre sınırı sayılır;
    // \'hh ve \uN kaçışları çözülür; font/renk/stil tabloları atlanır.
    extractLinesFromRtf(rtf) {
      const lines = [];
      let cur = '';
      const pushBreak = () => {
        const s = cur.replace(/\s+/g, ' ').trim();
        if (s) lines.push(s);
        cur = '';
      };
      // atlanacak hedef grupları (içerikleri metin değil)
      const SKIP_DEST = new Set([
        'fonttbl', 'colortbl', 'stylesheet', 'info', 'pict', 'object',
        'header', 'footer', 'headerl', 'headerr', 'footerl', 'footerr',
        'generator', 'filetbl', 'listtable', 'listoverridetable', 'rsidtbl',
        'themedata', 'datastore', 'latentstyles', 'mmath', 'fldinst',
      ]);
      // satır/hücre sonu üreten kontrol kelimeleri
      const BREAKS = new Set([
        'par', 'line', 'cell', 'row', 'nestcell', 'nestrow', 'sect',
      ]);

      const n = rtf.length;
      const ignoreStack = [];
      let ignore = false;     // o anki grup metin dışı mı
      let ucSkip = 1;         // \uN sonrası atlanacak fallback karakter sayısı
      let i = 0;
      while (i < n) {
        const ch = rtf[i];
        if (ch === '{') { ignoreStack.push(ignore); i++; continue; }
        if (ch === '}') { ignore = ignoreStack.length ? ignoreStack.pop() : false; i++; continue; }
        if (ch === '\\') {
          const next = rtf[i + 1];
          if (next === '\\' || next === '{' || next === '}') {
            if (!ignore) cur += next;
            i += 2;
            continue;
          }
          if (next === "'") {
            const code = parseInt(rtf.substr(i + 2, 2), 16);
            if (!ignore && !isNaN(code)) cur += String.fromCharCode(code);
            i += 4;
            continue;
          }
          if (next === '*') { ignore = true; i += 2; continue; }
          // kontrol kelimesi: \harfler[-?sayı][boşluk]
          let j = i + 1;
          let word = '';
          while (j < n && /[a-zA-Z]/.test(rtf[j])) { word += rtf[j]; j++; }
          let param = '';
          if (rtf[j] === '-') { param = '-'; j++; }
          while (j < n && /[0-9]/.test(rtf[j])) { param += rtf[j]; j++; }
          if (rtf[j] === ' ') j++; // sınır boşluğunu yut
          i = j;
          if (word === 'uc') { ucSkip = param ? parseInt(param, 10) : 1; continue; }
          if (word === 'u') {
            if (!ignore && param) {
              let cp = parseInt(param, 10);
              if (cp < 0) cp += 65536;
              cur += String.fromCharCode(cp);
            }
            // fallback temsilini atla
            let skip = ucSkip;
            while (skip > 0 && i < n) {
              if (rtf[i] === '\\' && rtf[i + 1] === "'") i += 4;
              else i += 1;
              skip--;
            }
            continue;
          }
          if (word === 'tab') { if (!ignore) cur += ' '; continue; }
          if (BREAKS.has(word)) { if (!ignore) pushBreak(); continue; }
          if (SKIP_DEST.has(word)) { ignore = true; continue; }
          continue; // diğer tüm kontrol kelimeleri: yok say
        }
        if (ch === '\r' || ch === '\n') { i++; continue; }
        if (!ignore) cur += ch;
        i++;
      }
      pushBreak();
      return lines;
    },

    // PDF metnini pdf.js ile çıkarır. Her metin parçası konumla yerleştirilir;
    // aynı Y'deki parçalar bir satır, X'e göre soldan sağa sıralanır. Sonuç
    // satırları docx/rtf'ten farklı (satır-içi "Etiket: değer"); normalizePdfLines
    // bunları kanonik biçime çevirir.
    async extractLinesFromPdf(buffer) {
      const doc = await pdfjsLib.getDocument({
        data: new Uint8Array(buffer),
        isEvalSupported: false,
      }).promise;
      const raw = [];
      for (let pn = 1; pn <= doc.numPages; pn++) {
        const page = await doc.getPage(pn);
        const tc = await page.getTextContent();
        const rows = [];
        for (const it of tc.items) {
          if (!it.str) continue;
          const x = it.transform[4], y = it.transform[5], w = it.width;
          let row = rows.find((r) => Math.abs(r.y - y) < 3);
          if (!row) { row = { y, parts: [] }; rows.push(row); }
          row.parts.push({ x, w, str: it.str });
        }
        rows.sort((a, b) => b.y - a.y); // üstten alta
        for (const r of rows) {
          r.parts.sort((a, b) => a.x - b.x); // soldan sağa
          let line = '', prevEnd = null;
          for (const p of r.parts) {
            if (prevEnd !== null) {
              const gap = p.x - prevEnd;
              // gerçek boşluk: kerning kaymalarını boşluk sanmamak için eşik
              if (gap > 1.0 && !line.endsWith(' ') && !p.str.startsWith(' ')) line += ' ';
            }
            line += p.str;
            prevEnd = p.x + p.w;
          }
          line = line.replace(/\s+/g, ' ').trim();
          if (line) raw.push(line);
        }
      }
      return this.normalizePdfLines(raw);
    },

    // PDF'in satır-içi düzenini docx/rtf'in kanonik satır dizisine çevirir:
    // çok-etiketli satırları "Etiket:" + değer parçalarına böler, müşteri
    // satırlarını (resNo title ad yaş doğum) ayrı alanlara açar.
    normalizePdfLines(raw) {
      // bilinen etiketler (LABEL_MAP + PDF'e özgü, eşleşmeyen) — uzun olan önce
      const labels = Object.keys(LABEL_MAP)
        .concat(['Fax', 'FAX', 'TEL'])
        .sort((a, b) => b.length - a.length);
      const esc = (s) => s.replace(/[.+*?^${}()|[\]\\]/g, '\\$&');
      const labelRe = new RegExp('(' + labels.map(esc).join('|') + ')\\s*:', 'g');

      const splitLabelLine = (line) => {
        const ms = [...line.matchAll(labelRe)];
        if (!ms.length) return [line];
        const res = [];
        if (ms[0].index > 0) {
          const pre = line.slice(0, ms[0].index).trim();
          if (pre) res.push(pre);
        }
        for (let k = 0; k < ms.length; k++) {
          const m = ms[k];
          const valStart = m.index + m[0].length;
          const valEnd = (k + 1 < ms.length) ? ms[k + 1].index : line.length;
          const val = line.slice(valStart, valEnd).trim();
          res.push(m[1] + ':');
          if (val) res.push(val);
        }
        return res.filter(Boolean);
      };

      const splitClientLine = (line) => {
        const t = line.trim().split(/\s+/);
        const resNo = t[0], title = t[1] || '';
        let rest = t.slice(2), birthDate = null, age = null;
        if (rest.length && /^\d{1,2}\.\d{1,2}\.\d{4}/.test(rest[rest.length - 1])) birthDate = rest.pop();
        if (rest.length && /^\d{1,3}$/.test(rest[rest.length - 1])) age = rest.pop();
        const out = [resNo, title, rest.join(' ')];
        if (age) out.push(age);
        if (birthDate) out.push(birthDate);
        return out.filter(Boolean);
      };

      const out = [];
      let inClients = false;
      for (const line of raw) {
        if (/Clients names/.test(line)) {
          out.push('Res.No', 'Clients names', 'Age');
          inClients = true;
          continue;
        }
        if (/^Pax\s*:/.test(line)) {
          inClients = false;
          out.push(...splitLabelLine(line));
          continue;
        }
        if (inClients && /^\d{5,}\s/.test(line)) {
          out.push(...splitClientLine(line));
          continue;
        }
        out.push(...splitLabelLine(line));
      }
      return out;
    },

    // Bir satırın LABEL_MAP etiketi olup olmadığını söyler ("Room:", "Manager:" vb.)
    isLabelLine(line) {
      for (const label of Object.keys(LABEL_MAP)) {
        if (line === label + ':' || line.startsWith(label + ':')) return true;
      }
      return false;
    },

    // Dökümandaki rezervasyonları "Pax:" sınırlarına göre böler.
    // Paylaşılan üst başlık (Firm, durum, Hotel...) ilk blokta yer alır ve
    // diğer rezervasyonlara devredilir; "Pax:" sonrası footer (Manager vb.)
    // tüm bloklara eklenir. Her blok parseVoucher ile ayrıştırılır.
    parseVouchers(lines) {
      const paxIdxs = [];
      for (let i = 0; i < lines.length; i++) {
        if (lines[i] === 'Pax:') paxIdxs.push(i);
      }
      // tek (veya hiç) rezervasyon: mevcut davranış, tek elemanlı dizi
      if (paxIdxs.length <= 1) return [this.parseVoucher(lines)];

      // her segment kendi "Pax:" değerine kadar uzanır
      const segments = [];
      let segStart = 0;
      for (const p of paxIdxs) {
        let end = p + 1;
        while (
          end < lines.length &&
          !this.isLabelLine(lines[end]) &&
          !(lines[end] === 'Res.No' && lines[end + 1] === 'Clients names')
        ) {
          end++;
        }
        segments.push(lines.slice(segStart, end));
        segStart = end;
      }
      // son "Pax:" sonrası kalan paylaşılan footer satırları (Manager vb.)
      const footer = lines.slice(segStart);

      // ilk segment paylaşılan başlığı taşır; sonrakilere eksik alanları devret
      const firstFlat = this.parseVoucher(segments[0].concat(footer));
      return segments.map((seg, i) => {
        if (i === 0) return firstFlat;
        const segFlat = this.parseVoucher(seg.concat(footer));
        return { ...firstFlat, ...segFlat };
      });
    },

    parseVoucher(lines) {
      const result = {};

      // --- clients tablosunu ayır ---
      // Tablo başlığı: colon'suz "Res.No" + "Clients names". Bitiş: "Pax:" etiketi.
      const tableStart = lines.findIndex(
        (l, i) => l === 'Res.No' && lines[i + 1] === 'Clients names'
      );
      const tableEnd = lines.findIndex((l) => l === 'Pax:');

      let headerFooterLines = lines;
      if (tableStart !== -1 && tableEnd !== -1) {
        // tablo gövdesi: başlık (Res.No, Clients names, Age = 3 satır) sonrası
        const rows = lines.slice(tableStart + 3, tableEnd);
        // Satırlar değişken uzunlukta: yetişkin = [resNo, title, fullName],
        // çocuk = [resNo, title, fullName, age, birthDate]. Bu yüzden sabit
        // gruplama yerine her yeni Res.No (uzun sayısal) değerinde yeni müşteri başlat.
        const isResNoCell = (s) => /^\d{5,}$/.test((s || '').trim());
        const groups = [];
        let cur = null;
        for (const cell of rows) {
          if (isResNoCell(cell)) {
            if (cur) groups.push(cur);
            cur = { resNo: cell.trim(), rest: [] };
          } else if (cur) {
            cur.rest.push(cell);
          }
        }
        if (cur) groups.push(cur);
        result.clients = groups.map((g) => {
          let age = null, birthDate = null;
          for (const x of g.rest.slice(2)) {
            if (/^\d{1,2}\.\d{1,2}\.\d{4}/.test(x)) birthDate = x;
            else if (/^\d{1,3}$/.test(x)) age = x;
          }
          return {
            resNo: g.resNo,
            title: g.rest[0] || null,
            fullName: g.rest[1] || null,
            age,
            birthDate,
          };
        });
        // etiket-değer akışı: tablo dışında kalan satırlar (öncesi + sonrası)
        headerFooterLines = lines.slice(0, tableStart).concat(lines.slice(tableEnd));
      }

      // --- etiket -> değer toplama ---
      // Etiketler iki formatta gelebilir:
      //   - ayrı hücre:  "Firm:" (sonraki satır[lar] değer)
      //   - inline:      "Phone: +90 242 ..." (değer aynı satırda)
      const collected = {};
      let currentKey = null;
      for (const line of headerFooterLines) {
        let matched = false;
        for (const label of Object.keys(LABEL_MAP)) {
          const key = LABEL_MAP[label];
          if (line === label + ':') {
            currentKey = key;
            collected[key] = [];
            matched = true;
            break;
          }
          if (line.startsWith(label + ':')) {
            collected[key] = [line.slice(label.length + 1).trim()];
            currentKey = null;
            matched = true;
            break;
          }
        }
        if (!matched && currentKey) collected[currentKey].push(line);
      }

      // --- özel alanları çıkar ---
      // status: "... RESERVATION" satırı (örn. CANCELED RESERVATION) herhangi bir değerin içinde olabilir
      for (const key of Object.keys(collected)) {
        const idx = collected[key].findIndex((v) => /RESERVATION$/i.test(v));
        if (idx !== -1) {
          result.status = collected[key][idx];
          collected[key].splice(idx, 1);
        }
      }

      // hotel: ad + "TEL: ..." + olası mail durumu (Resending vb.)
      if (collected.hotel) {
        const arr = collected.hotel;
        result.hotel = arr[0] || '';
        for (let i = 1; i < arr.length; i++) {
          const v = arr[i];
          if (/^TEL:/i.test(v)) {
            result.hotelTel = v.replace(/^TEL:\s*/i, '').trim();
          } else {
            result.mailStatus = v;
          }
        }
        delete collected.hotel;
      }

      // room: adet + oda tipi
      if (collected.room) {
        let parts = collected.room;
        // PDF'te "1 room(s) SUPERIOR LAND VIEW" tek satırda gelebilir -> ayır
        if (parts.length === 1) {
          const m = parts[0].match(/^(\d+\s*room\(s\))\s*(.*)$/i);
          if (m) parts = [m[1], m[2]];
        }
        result.roomCount = parts[0] || '';
        result.roomType = parts[1] || '';
        delete collected.room;
      }

      // geri kalan tüm etiketler: değer satırlarını birleştir
      for (const key of Object.keys(collected)) {
        result[key] = collected[key].join(' ').trim();
      }

      return result;
    },

    // --- flat -> rezervasyon modeli ---
    mapToReservation(v) {
      const persons = (v.clients || []).map((c) => {
        const code = this.genderCode(c.title);
        const { name, surname } = this.splitName(c.fullName); // Soyad Ad
        const age = c.age ? parseInt(c.age, 10) : null;
        return {
          Gender: {
            Code: code,
            Name: (c.title || '').toUpperCase(),
            ProviderGenderCode: null,
          },
          FullName: c.fullName || null,
          Name: name,
          Surname: surname,
          BirthDate: this.parseDate(c.birthDate),
          Age: age,
          CheckinDateAge: age,
          CustomerProviderAge: age,
          DocumentNumber: null,
          Citizenship: null,
          Note: null,
        };
      });

      // Pax: Gender 1/2 -> Adult, 3 -> Child, 4 -> Infant
      let adult = 0, child = 0, infant = 0;
      persons.forEach((p) => {
        if (p.Gender.Code === 1 || p.Gender.Code === 2) adult++;
        else if (p.Gender.Code === 3) child++;
        else if (p.Gender.Code === 4) infant++;
      });

      const conf = this.confirmationFromStatus(v.status);
      const resNo = v.resNo || null;

      // Notes: mevcut not + net fiyat ayrı item olarak
      const notes = [];
      if (v.note) notes.push({ Type: 'note', Content: v.note });
      if (v.netPrice) notes.push({ Type: 'price', Content: v.netPrice });

      return {
        ReservationCode: resNo,
        ConfirmationType: {
          Code: conf.Code,
          Name: conf.Name,
          ProviderConfirmationType: v.status || null,
        },
        ConfirmStatus: 0,
        ProviderHotelName: v.hotel || null,
        Agency: {
          Code: null,
          Name: v.firm || v.touroperator || null,
          TourOperatorName: v.touroperator || null,
          FullName: v.firm || v.touroperator || null,
        },
        Voucher: {
          Full: resNo,
          Operator: resNo,
          Client: resNo,
          CustomerVoucher: resNo,
        },
        Room: {
          Name: v.roomType || null,
          RoomDetail: v.accomType || null,
          Count: this.firstInt(v.roomCount, 1),
        },
        Pax: {
          Adult: adult,
          Child: child,
          Infant: infant,
          ProviderPaxDetails: null,
          Total: persons.length,
          IncorrectPaxInformation: false,
          Age1: null,
          Age2: null,
          Age3: null,
          Age4: null,
        },
        Pension: v.meal || null, // dökümandaki haliyle (örn. "UAI")
        Checkin: this.parseDate(v.checkInDate),
        Checkout: this.parseDate(v.checkOutDate),
        NightCount: this.firstInt(v.nights, null),
        ProviderMarket: v.market || null,
        Parameters: { P1: null, P2: null, P3: null, P4: null, P5: null },
        Sale: {
          Date: this.parseDate(v.reservationDate),
          IsAgencySaleDate: !!v.reservationDate,
        },
        Persons: persons,
        Notes: notes,
        Departure: { Date: null, FlightCode: null, City: null },
        Arrival: { Date: null, FlightCode: null, City: null },
        DetailContent: null,
        IsMail: true,
        MailId: null,
        BoundKey: null,
        ConfirmLink: null,
        NotConfirmLink: null,
        FileName: null,
        DetailContentUrl: null,
        FileDownloaded: false,
      };
    },

    // MRS/MR/CHD/INF -> Gender.Code (Mr=1, Mrs=2, Chd=3, Inf=4, None=-1)
    genderCode(title) {
      const t = (title || '').toUpperCase().trim();
      if (t === 'MR') return 1;
      if (t === 'MRS' || t === 'MISS' || t === 'MS') return 2;
      if (t === 'CHD' || t === 'CHILD') return 3;
      if (t === 'INF' || t === 'INFANT') return 4;
      return -1;
    },

    // "ENINA VIKTORIIA" -> { surname: "ENINA", name: "VIKTORIIA" }  (Soyad Ad)
    splitName(full) {
      const parts = (full || '').trim().split(/\s+/).filter(Boolean);
      if (parts.length === 0) return { name: null, surname: null };
      if (parts.length === 1) return { name: parts[0], surname: null };
      return { surname: parts[0], name: parts.slice(1).join(' ') };
    },

    // status -> ConfirmationType (new=1, changed=2, cancel=3, none=-1)
    confirmationFromStatus(status) {
      const s = (status || '').toUpperCase();
      if (/CANCEL/.test(s)) return { Code: 3, Name: 'Cancelled' };
      if (/CHANGE|AMEND|MODIF/.test(s)) return { Code: 2, Name: 'Changed' };
      if (/NEW|BOOK|CONFIRM/.test(s)) return { Code: 1, Name: 'New' };
      return { Code: -1, Name: 'None' };
    },

    // "05.07.2026" veya "2.03.2026 10:23:00" -> "2026-07-05T00:00:00"
    parseDate(str) {
      if (!str) return null;
      const m = String(str).trim().match(
        /^(\d{1,2})\.(\d{1,2})\.(\d{4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?$/
      );
      if (!m) return null;
      const pad = (n) => String(n).padStart(2, '0');
      const [, d, mo, y, h = '00', mi = '00', s = '00'] = m;
      return `${y}-${pad(mo)}-${pad(d)}T${pad(h)}:${pad(mi)}:${pad(s)}`;
    },

    // ilk sayıyı çek ("1 room(s)" -> 1), yoksa fallback
    firstInt(str, fallback) {
      const m = String(str == null ? '' : str).match(/\d+/);
      return m ? Number(m[0]) : fallback;
    },
  },
};
</script>
